import { render, staticRenderFns } from "./OtherOrganization.vue?vue&type=template&id=e27fd3e4&scoped=true&"
import script from "./OtherOrganization.vue?vue&type=script&lang=js&"
export * from "./OtherOrganization.vue?vue&type=script&lang=js&"
import style0 from "./OtherOrganization.vue?vue&type=style&index=0&id=e27fd3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27fd3e4",
  null
  
)

export default component.exports